(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsListTemplateView', rmsListTemplateView);

    /**
     * Receives options
     * - Includes templates per list-item, datasource/data, and others
     * Receives Model
     * - Set selection of list-item
     * Expose Events
     * - Refresh by external factors
     * Expose Model
     * - Get selection of list-item
     */
    function rmsListTemplateView(lodash) {
        return {
            restrict: 'E',
            scope: {
                options: '=', // options of the kendo-listview
                // model: '=', // get/set model
                refresh: '=',
                change: '&?ngChange'
            },
            require:'ngModel',
            controller: rmsListTemplateViewCtrl,
            controllerAs: 'vm',
            bindToController: true,
            link: rmsListTemplateViewLink
        };

        function rmsListTemplateViewLink(scope, elem, attr, ctrl) {
            var vm = scope.vm;

            ctrl.$formatters.push(function(_item) {
               if (!lodash.has(_item, 'selected')) {
                   _item.selected = [];
               }
               return _item;
            });

            ctrl.$render = function() {
                lodash.set(vm.stateData, 'model', ctrl.$viewValue);
            }

            lodash.set(vm.stateData, 'events.onChange', function() {
                ctrl.$setViewValue(vm.stateData.model);
                if (typeof vm.change == typeof function() {}) {
                    vm.change();
                }
            });
        }
    }

    function rmsListTemplateViewCtrl($scope, ListTemplateViewStateService, $compile, $element, lodash, $timeout) {
        const vm = this;
        this.$onInit = function() {
            // If not templates, just exit. No point trying to load the directive
            if (!lodash.has(vm.options, 'templates') && !lodash.has(vm.options, 'templateUrl')) {
                return;
            }

            // setting the $id of this directive. In case this directive is used multiple times in a view.
            vm.rmsListTemplateView = $scope.$id;

            // initialise the service
            ListTemplateViewStateService.init(vm, vm.rmsListTemplateView, vm.options || {});
            if (vm.model) {
                vm.service().syncModel(vm);
            }
            vm.service().syncState(vm);


            // preparing the various events listener that the templates can listen to
            vm.events = {
                refreshDatasource: vm.service().refreshDatasource,
                toggleSelected: vm.service().toggleSelected,
                action: vm.service().action,
                clearSelection: vm.service().clearSelection,
                hasNoSelection: vm.service().hasNoSelection,
            };

            vm.refresh = vm.events.refreshDatasource;

            $element.html(vm.stateData.listOptions.templates);
            const cloneElement = $compile($element.contents())($scope);

            // proper garbage collection
            $scope.$on('destroy', () => {
                ListTemplateViewStateService.destroy(vm.rmsListTemplateView);
                cloneElement.off();
            });
        }
    }
})();